import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { isValid } from './auth';
import useStateWithLocalStorage from './useStateWithLocalStorage';

export default function ProtectedRoutes() {
  const [token, setToken] = useStateWithLocalStorage('token');

  // Clear expired tokens automatically
  useEffect(() => {
    if (token && !isValid(token)) {
      console.log('Token has expired, clearing it...');
      setToken("");
    }
  }, [token, setToken]);

  const isAuthenticated = isValid(token);
  const { lang } = useParams();

  if (!isAuthenticated) {
    console.log('User not authenticated, redirecting to login...');
    return <Navigate to={`/${lang}/login`} replace />;
  }

  return <Outlet />;
}